"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createClient;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/regeneratorRuntime"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _common = _interopRequireDefault(require("../common"));
var _app = _interopRequireDefault(require("./app"));
var _history = _interopRequireDefault(require("./history"));
var _middlewares = _interopRequireDefault(require("./middlewares"));
var _config = _interopRequireDefault(require("./config"));
var _utils = require("../common/utils");
var _excluded = ["disableUseDefaultMiddlewares", "styles"];
function createClient() {
  var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var wapp = p.wapp || (0, _common["default"])(p);
  var _createConfig = (0, _config["default"])(p),
    config = _createConfig.config;
  var clientConfig = config.client || {};
  var _clientConfig$disable = clientConfig.disableUseDefaultMiddlewares,
    disableUseDefaultMiddlewares = _clientConfig$disable === void 0 ? false : _clientConfig$disable,
    _clientConfig$styles = clientConfig.styles,
    styles = _clientConfig$styles === void 0 ? {} : _clientConfig$styles,
    rest = (0, _objectWithoutProperties2["default"])(clientConfig, _excluded);
  var _styles$disableClearM = styles.disableClearMainStyle,
    disableClearMainStyle = _styles$disableClearM === void 0 ? false : _styles$disableClearM;
  var defaultConfig = Object.create(Object.prototype, {
    disableUseDefaultMiddlewares: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: disableUseDefaultMiddlewares
    })
  });
  (0, _utils.mergeProperties)(defaultConfig, wapp.config);
  (0, _utils.mergeProperties)(defaultConfig, rest);
  var app = (0, _app["default"])({
    wapp: wapp
  });
  var history = (0, _history["default"])({
    wapp: wapp
  });
  function defaultListen() {
    wapplrClient.close();
    wapplrClient.history.listen(function (_ref) {
      var action = _ref.action,
        location = _ref.location,
        state = _ref.state;
      wapplrClient.app({
        history: {
          action: action,
          location: location,
          state: state
        }
      });
    });
    wapplrClient.app({
      history: {
        action: "POP",
        location: {
          pathname: window.location.pathname,
          search: window.location.search,
          hash: window.location.hash
        },
        state: window.history.state || {
          key: "initial"
        }
      }
    }, {}, function out() {
      var globals = wapp.globals;
      var WAPP = globals.WAPP;
      if (!disableClearMainStyle) {
        setTimeout(function () {
          var elem = document.getElementById("css_" + WAPP);
          if (elem) {
            elem.parentNode.removeChild(elem);
          }
        }, 2000);
      }
    });
  }
  function defaultClose() {
    wapplrClient.history.close();
  }
  var defaultMiddlewares = (0, _middlewares["default"])((0, _objectSpread2["default"])({
    wapp: wapp
  }, p));
  var wapplrClient = Object.create(Object.prototype, {
    config: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      writable: false,
      value: defaultConfig
    }),
    listen: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: defaultListen
    }),
    close: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: defaultClose
    }),
    history: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: history
    }),
    app: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: app
    }),
    middlewares: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: defaultMiddlewares
    })
  });
  Object.defineProperty(wapplrClient, "wapp", (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
    writable: false,
    enumerable: false,
    value: wapp
  }));
  Object.defineProperty(wapp, "client", (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
    value: wapplrClient
  }));
  app.use( /*#__PURE__*/function () {
    var _defaultMiddlewaresWrapper = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee3(req, res, out) {
      var next, middlewares, index;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (wapplrClient.config.disableUseDefaultMiddlewares) {
              _context3.next = 7;
              break;
            }
            next = /*#__PURE__*/function () {
              var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee2(err) {
                var func, defaultArgs, args;
                return (0, _regeneratorRuntime2["default"])().wrap(function _callee2$(_context2) {
                  while (1) switch (_context2.prev = _context2.next) {
                    case 0:
                      if (!middlewares[index]) {
                        _context2.next = 19;
                        break;
                      }
                      func = middlewares[index];
                      index = index + 1;
                      defaultArgs = [req, res, err ? /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee() {
                        return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
                          while (1) switch (_context.prev = _context.next) {
                            case 0:
                              _context.next = 2;
                              return next(err);
                            case 2:
                            case "end":
                              return _context.stop();
                          }
                        }, _callee);
                      })) : next];
                      args = func.length === 4 && err ? [err].concat(defaultArgs) : defaultArgs;
                      _context2.prev = 5;
                      _context2.next = 8;
                      return func.apply(void 0, (0, _toConsumableArray2["default"])(args));
                    case 8:
                      return _context2.abrupt("return", _context2.sent);
                    case 11:
                      _context2.prev = 11;
                      _context2.t0 = _context2["catch"](5);
                      res.wappResponse.status(500, _context2.t0);
                      _context2.next = 16;
                      return next(_context2.t0);
                    case 16:
                      return _context2.abrupt("return", _context2.sent);
                    case 17:
                      _context2.next = 22;
                      break;
                    case 19:
                      if (!(typeof out === "function")) {
                        _context2.next = 22;
                        break;
                      }
                      index = 0;
                      return _context2.abrupt("return", out(err));
                    case 22:
                      return _context2.abrupt("return", null);
                    case 23:
                    case "end":
                      return _context2.stop();
                  }
                }, _callee2, null, [[5, 11]]);
              }));
              return function next(_x4) {
                return _ref2.apply(this, arguments);
              };
            }();
            middlewares = Object.keys(wapplrClient.middlewares).map(function (key) {
              return wapplrClient.middlewares[key];
            });
            index = 0;
            _context3.next = 6;
            return next();
          case 6:
            return _context3.abrupt("return", _context3.sent);
          case 7:
            _context3.next = 9;
            return out();
          case 9:
            return _context3.abrupt("return", _context3.sent);
          case 10:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    function defaultMiddlewaresWrapper(_x, _x2, _x3) {
      return _defaultMiddlewaresWrapper.apply(this, arguments);
    }
    return defaultMiddlewaresWrapper;
  }());
  return wapp;
}